import { useImmer } from "use-immer";
import { STEPS_STATES } from "../constants";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook para controlar los pasos de un stepper.
 * @returns {{
 *   steps: Array<{index: number, path: string, currentState: string, backward?: boolean}>,
 *   setStepState: (index: number, state: string) => void,
 * }}
 */
export const useStepsController = () => {
	const location = useLocation();
	const [steps, setSteps] = useImmer([
		{
			index: 1,
			path: "/crear-perfil/paso-1",
			currentState: STEPS_STATES.ACTIVE,
			backward:false,
		},
		{
			index: 2,
			path: "/crear-perfil/paso-2",
			currentState: STEPS_STATES.DISABLED,
			backward:true
		},
		{
			index: 3,
			path: "/crear-perfil/paso-3",
			currentState: STEPS_STATES.DISABLED,
			backward:false
		},
	]);

	const setStepState = (index, state) => {
		setSteps((draft) => {
			draft[index - 1].currentState = state;
		});
	};

	const stepsHandler = ()=>{
		setSteps(draft=>{
			const step =  draft.find(step=>step?.path === location?.pathname);
			if(!step){return draft}
			const currentStepIndex = step?.index;
			if(currentStepIndex < 0 || !currentStepIndex){return draft}
			draft.forEach(step=>{
				if(step.index < currentStepIndex){
					step.currentState = STEPS_STATES.COMPLETED;
				}
				else if(step.index > currentStepIndex){
					step.currentState = STEPS_STATES.DISABLED;
				}
				else{
					step.currentState = STEPS_STATES.ACTIVE;
				}
			
			})
		})
	}

	useEffect(()=>{
		stepsHandler();
	},[location.pathname])

	return {
		steps,
		setStepState,
	};
};
